const CartUtil = {
    checkLoginAndGoToCheckout: function (isMiniCart) {
        CartUtil.sendAnalytics(isMiniCart);
        if (!isAuthenticated) {
            CartUtil.loadLogin();
        } else {
            CartSummary.disableCheckout(true);
        }
    },

    loadLogin: function () {
        pushDataLayerCheckoutLogin();
        CartUtil.goToCheckout();
    },

    sendAnalytics: function (isMiniCart) {
        pushCheckoutProductsMetrics(isMiniCart ? '.mini--cart--product' : '.product-card', 1, isAuthenticated ? CartUtil.goToCheckout : null, true);
    },

    goToCheckout: function () {
        window.location.href = checkoutUrl;
    }
};